import { render, staticRenderFns } from "./synced-with-expert-status.vue?vue&type=template&id=68b36bb6"
import script from "./synced-with-expert-status.vue?vue&type=script&lang=js"
export * from "./synced-with-expert-status.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports